import { useEffect, useState } from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { api, api_error } from '../api'

/** Rahmen des Adminbereichs samt Anmeldung — Benutzername und Passwort, kein Magic Link. */
export function AdminLayout() {
  const [username, set_username] = useState<string | null>(null)
  const [checked, set_checked] = useState(false)

  async function check() {
    try {
      const me = await api.admin_me()
      set_username(me.username)
    } catch {
      set_username(null)
    } finally {
      set_checked(true)
    }
  }

  useEffect(() => {
    void check()
  }, [])

  if (!checked) return <div className="page muted">Wird geladen …</div>
  if (!username) return <AdminLogin on_success={check} />

  return (
    <>
      <header className="bar">
        <div className="inner">
          <strong>Belegportal</strong>
          <nav>
            <NavLink to="/admin/pruefen">Zu prüfen</NavLink>
            <NavLink to="/admin/benutzer">Benutzer</NavLink>
            <NavLink to="/admin/protokoll">Protokoll</NavLink>
          </nav>
          <span className="muted small">{username}</span>
          <button
            onClick={async () => {
              await api.admin_logout()
              set_username(null)
            }}
          >
            Abmelden
          </button>
        </div>
      </header>
      <Outlet />
    </>
  )
}

function AdminLogin(props: { on_success: () => void }) {
  const [username, set_username] = useState('')
  const [password, set_password] = useState('')
  const [error, set_error] = useState<string | null>(null)
  const [busy, set_busy] = useState(false)
  const navigate = useNavigate()

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    set_busy(true)
    set_error(null)
    try {
      await api.admin_login(username, password)
      props.on_success()
      navigate('/admin/pruefen')
    } catch (caught) {
      set_error(
        caught instanceof api_error ? caught.message : 'Anmeldung fehlgeschlagen',
      )
    } finally {
      set_busy(false)
    }
  }

  return (
    <div className="page center">
      <form className="card" onSubmit={submit}>
        <h1>Anmeldung</h1>
        {error && <div className="notice notice--error">{error}</div>}
        <div className="field">
          <label htmlFor="username">Benutzername</label>
          <input
            id="username"
            type="text"
            autoComplete="username"
            value={username}
            onChange={(event) => set_username(event.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="password">Passwort</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => set_password(event.target.value)}
          />
        </div>
        <button className="primary" type="submit" disabled={busy}>
          {busy ? 'Anmelden …' : 'Anmelden'}
        </button>
      </form>
    </div>
  )
}
